export default {
  method: {
    pagination (context, objectName, data) {
      context[objectName].showMore = false
      if (data.length >= (context[objectName].limit + 1)) {
        context[objectName].showMore = true
        data.splice(context[objectName].limit)
      }
      context[objectName].data = context[objectName].data.concat(data)
      context[objectName].offset += context[objectName].limit
    },
    defaultObject () {
      return {
        data: [],
        limit: 5,
        offset: 0,
        showMore: false
      }
    }
  }
}
